import { IAllocatableHistoryResponse } from '../../../@types/allocatable-history.type';
import { getErrorMessage } from '../../../utils/utils';
import { Api } from '../ApiConfig';
import { ApiException } from '../ApiException';

export const getAllocatableHistoryByResourceId = async (resourceId: string) => {
  try {
    const { data } = await Api.get<IAllocatableHistoryResponse>(
      `api/Resource/AllocatableHistory/${resourceId}`
    );
    return data.result || [];
  } catch (error) {
    throw new ApiException(
      getErrorMessage(error, 'Erro ao buscar histórico de alocabilidade')
    );
  }
};
